import { PinPermissions } from 'stream-chat-react';

export const MESSAGE_ACTIONS = ['edit', 'delete', 'mute', 'pin', 'react', 'reply'];

export const PIN_PERMISSIONS: PinPermissions = {
  comments: {
    admin: true,
    anonymous: false,
    channel_member: false,
    channel_moderator: true,
    guest: false,
    member: false,
    moderator: true,
    owner: false,
    user: false,
  },
};
